/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Menu_Project_HistoryInputs */



/**
* | output |
* | --- |
* | "Project History" |
*
* @param {Team_Menu_Project_HistoryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_menu_project_history = /** @type {((inputs?: Team_Menu_Project_HistoryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Menu_Project_HistoryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Historique du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektgeschichte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cronologia del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("История проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Historial del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目历史")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトの履歴")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परियोजना इतिहास")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Histórico do projeto")
	return /** @type {LocalizedString} */ ("Project History")
});